export default __webpack_public_path__ + "static/media/title_zh_cn_pc.b37de4db.png";